import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { EpsPlan } from '../entities/eps-plan';

@Injectable()
export class EpsPlanService extends BaseCrudService<EpsPlan> {

  public uri = '/api/epsPlan/';

  constructor(injector: Injector) {
    super(injector);
  //  console.log('Instance EpsPlanService');
  }

  buildSentence(entity?: EpsPlan, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.name ?
          `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.abbreviation ?
          `abbreviation${QueryOperator.Contain}${entity.abbreviation}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.amount ?
          `amount${QueryOperator.Contain}${entity.amount}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.status ?
          `status${QueryOperator.Equal}${entity.status}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.eps && entity.eps.id) {
        query = query.concat(
          `eps.id${QueryOperator.Equal}${entity.eps}${QueryOperator.Split}`
        );
      }
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
            `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/eps-plan.service.ts